import GroupDetailModule from './GroupDetailModule'
export default GroupDetailModule
